import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Toast, ToastService } from './toast.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
})
export class ToastContainerComponent {
  private readonly router = inject(Router);
  toastService = inject(ToastService);
  toasts = this.toastService.toasts;

  onToastClick(toast: Toast, event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target.closest('.toast-close')) return;

    if (toast.actionRoute) {
      const route = toast.actionRoute;
      this.toastService.remove(toast.id);
      this.router.navigate([route]);
      return;
    }

    this.toastService.remove(toast.id);
  }

  remove(id: number, event?: MouseEvent): void {
    event?.stopPropagation();
    this.toastService.remove(id);
  }
}
